import './WhyUs.css';
import useTilt from '../useTilt';

// SVG icons (lucide-style) matching the approved design
const IconTrendingUp = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
    <polyline points="16 7 22 7 22 13" />
  </svg>
);
const IconZap = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);
const IconUsers = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const cards = [
  { Icon: IconTrendingUp, title: 'Results-Driven', desc: 'Every strategy is backed by data and focused on real, measurable outcomes for your business.', delay: 'd1' },
  { Icon: IconZap, title: 'Affordable Excellence', desc: 'Premium quality services at competitive pricing — enterprise-grade solutions without the enterprise cost.', delay: 'd2' },
  { Icon: IconUsers, title: 'Expert Team', desc: 'A passionate team of developers, designers, and marketers with years of combined industry experience.', delay: 'd3' },
];

function WhyCard({ c }) {
  const tilt = useTilt(8);
  return (
    <div
      className={`why-card reveal-scale ${c.delay}`}
      ref={tilt.ref}
      onMouseMove={tilt.onMouseMove}
      onMouseLeave={tilt.onMouseLeave}
    >
      <span className="why-icon"><c.Icon /></span>
      <h4>{c.title}</h4>
      <p>{c.desc}</p>
    </div>
  );
}

export default function WhyUs() {
  return (
    <section id="why" className="why-section">
      <div className="why-header">
        <span className="section-label reveal">Why Us</span>
        <h2 className="section-title reveal">Why Choose <em>Aerial Root?</em></h2>
        <p className="section-sub reveal why-sub">We combine technical expertise with creative thinking to deliver solutions that truly make a difference.</p>
      </div>
      <div className="why-grid">
        {cards.map(c => <WhyCard key={c.title} c={c} />)}
      </div>
    </section>
  );
}
